module.exports = __webpack_public_path__ + "static/img/tabbt2025_2.891da71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbt2025_2.png
// module id = sjHI
// module chunks = 1